



































































































































import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { FormState } from '@/components/prine/enums/FormState';
import DetailedConfirmModal from '@/components/prine/DetailedConfirmModal.vue';

import type { Phase } from '@/models/phase';
import type { User } from '@/models/user';
import { phaseWebservice } from '@/webservices/phase';
import PrineButton from '@/components/prine/PrineButton.vue';
import { hasPermission } from '@/helpers/auth/permissionHelpers';
import { PERMISSIONS } from '@/helpers/auth/permissions';

@Component({
    name: 'StoreUpdatePhase',
    computed: {
        PERMISSIONS() {
            return PERMISSIONS;
        },
    },
    methods: { hasPermission },
    components: {
        DetailedConfirmModal,
        PrineButton,
    },
})
export default class StoreUpdatePhase extends Vue {
    public FormState = FormState;

    // Data
    protected disabled: boolean = false;
    protected errorMsg: string = '';
    protected isConfirmModalActive: boolean = false;
    protected state: FormState = FormState.New;

    protected phase: Phase = {} as Phase;
    protected loading = {
        data: false,
        color: '#fdc05d',
        size: '40px',
    };

    protected affectedData: Map<string, number> = new Map();

    @Getter('account/userInfo') private userInfo: User;

    // Mounted is called initially
    private mounted() {
        if (this.$route.query.hasOwnProperty('phaseId')) {
            this.load(Number.parseInt(this.$route.query.phaseId.toString()));
            this.state = FormState.Update;
        }
    }

    private load(phaseId: number) {
        this.loading.data = true;
        phaseWebservice.getById(phaseId).then((response) => {
            this.phase = response.data;
            this.loading.data = false;
            this.affectedData.set(this.$tc('keywords.lesson', 2).toString(), this.phase.lessons_count);
        });
    }

    private save() {
        this.disabled = true;
        const self = this;
        if (!this.validate()) {
            this.disabled = false;
            return 0;
        }

        if (this.state === FormState.New) {
            phaseWebservice
                .store(this.phase)
                .then((response) => {
                    this.$buefy.toast.open({
                        duration: 3000,
                        message: this.$t('toastMessages.store.phase').toString(),
                        type: 'is-success',
                    });
                    this.$emit('syncKnowledge');
                    this.$router.push({ path: '/knowledge/phases' });
                })
                .catch((error) => {
                    this.disabled = false;
                    console.log(error);
                });
        } else if (this.state === FormState.Update) {
            phaseWebservice
                .update(this.phase)
                .then((response) => {
                    this.$buefy.toast.open({
                        duration: 3000,
                        message: this.$t('toastMessages.update.phase').toString(),
                        type: 'is-success',
                    });
                    this.$emit('syncKnowledge');
                    this.$router.push({ path: '/knowledge/phases' });
                    this.disabled = false;
                })
                .catch((error) => {
                    this.disabled = false;
                    console.log(error);
                });
        }
    }

    private toggleConfirmModal(answer) {
        this.isConfirmModalActive = !this.isConfirmModalActive;
        if (answer === true) {
            this.remove();
        }
    }

    private remove() {
        const self = this;
        phaseWebservice
            .remove(this.phase)
            .then((response) => {
                this.$buefy.toast.open({
                    duration: 3000,
                    message: this.$t('toastMessages.delete.phase').toString(),
                    type: 'is-success',
                });
                this.$router.push({ path: '/knowledge/phases' });
            })
            .catch((error) => {
                console.log(error);
            });
    }

    private validate() {
        if (!this.phase.title || this.phase.title === '') {
            this.errorMsg = 'title';
            return 0;
        } else if (!this.phase.abbreviation || this.phase.abbreviation === '') {
            this.errorMsg = 'abbreviation';
            return 0;
        } else if (!this.phase.order) {
            this.errorMsg = 'order';
            return 0;
        } else {
            return true;
        }
    }
}
